export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  gap: '16px',
};

export const groupHeaderStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px',
};

export const itemsFiltersWrapperStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  gap: '8px',
};

export const itemsFilterFieldStyles = {
  flex: '1 1 160px',
  minWidth: '140px',
};

export const itemsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const statusBlockStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: '16px',
};
